import {TreatmentTarget} from '../treatments/treatment_target'
export class PbxHangupTreatment extends TreatmentTarget {
  constructor() {
    super();
  }

  isTarget() {
    return false;
  }

  connectedCallback() {
    this.innerHTML = 
      `<div class="col-sm-12 ct_action" data-action_type=HANGUP>
        <div class="panel panel-default">
            <h4>Call Hangs Up</h4><a class="remove"><i class="fa fa-times" aria-hidden="true"></i></a>
            <div class="col-sm-12">
              <p>The call ends</p>
            </div>
        </div>
      </div>
      <!--div class="col-sm-12 ct_line">
        <div class="ct_vertical_arrow"></div>
        <div class="option_text">Sales Rep is being Called</div>
        <div class="ct_vertical_arrow">
          <div class=arrow-down></div>
        </div>
      </div-->
    `;
    super.connectedCallback();
  }
}

customElements.define('pbx-hangup-treatment', PbxHangupTreatment);